import { memo } from 'react'
import { ClockIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

/**
 * TodayHoursChip - Compact chip showing today's schedule hours
 * Shows nothing when no schedule slot exists for today.
 *
 * @param {string|null} todayOpenTime  - HH:MM:SS from entity_schedules
 * @param {string|null} todayCloseTime - HH:MM:SS from entity_schedules
 * @idempotent @atomic
 */
const TodayHoursChip = memo(function TodayHoursChip({ todayOpenTime, todayCloseTime }) {
  const { t } = useTranslation()

  if (!todayOpenTime || !todayCloseTime) return null

  // Format "HH:MM:SS" → "H:MM AM/PM"
  const fmt = (timeStr) => {
    const [h, m] = timeStr.split(':').map(Number)
    const ampm = h >= 12 ? 'PM' : 'AM'
    const hour = h % 12 || 12
    return `${hour}:${String(m).padStart(2, '0')} ${ampm}`
  }

  return (
    <span className="inline-flex items-center gap-1 text-xs text-green-700 bg-green-50 border border-green-200 rounded-full px-2 py-0.5">
      <ClockIcon className="w-3 h-3 flex-shrink-0" />
      <span>{t('schedule.openToday', 'Open today')}: {fmt(todayOpenTime)} – {fmt(todayCloseTime)}</span>
    </span>
  )
})

export default TodayHoursChip
